import BaseModel from '../core/BaseModel'
export default class RequestActivationProductSerialExpandModel extends BaseModel {
    constructor() {
        super({ 
                name: "request_activation_product_serial_expand",
                tableName: 'core_request_activation_product_serial'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID',
                primaryKey: true,
                display: false,
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                filter: { type: 'DateRange', match: 'custom'}
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                computed: (data) => {
                    data.full_name = (data.customer_profile !== undefined && data.customer_profile !== null) ? data.customer_profile.full_name  :  '';
                }
            },
            organization_id: { 
                name: 'organization_id', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                computed: (data) => {
                    data.organization_id = (data.organizations !== undefined && data.organizations !== null) ? data.organizations.name  :  '';
                }
            },
            content: { 
                name: 'content', 
                type: "String", 
                label: 'Nội dung cập nhật',
                computed: (data) => {
                    data.content = data.message;
                }
            },
            verifyStatus: { 
                name: 'verifyStatus', 
                type: "Selection",
                label: 'Trạng thái nghiệm thu',
                dataType: 'Label',
                class: 'center',
                options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                computed: (data) => {
                    if (data.request_activation_product_serial != undefined && data.request_activation_product_serial != null && Object.keys(data.request_activation_product_serial).length) {
                        data.verifyStatus = data.request_activation_product_serial[0].warranty_status
                    }
                }
            },
            warrantyStatus: { 
                name: 'warrantyStatus', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label',
                class: 'center',
                options: [{ value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, { value: 0, label: 'Sản phẩm huỷ'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                computed: (data) => {
                    if (data.request_activation_product_serial != undefined && data.request_activation_product_serial != null && Object.keys(data.request_activation_product_serial).length) {
                        data.warrantyStatus = (data.request_activation_product_serial[0].warranty_status == 5) ? 0 : data.request_activation_product_serial[0].warranty_status;
                    }
                }
            },
            user_id: {
                refs: 'product_serial_number { serial_number }',
                display: false
            }
        },)
    }

}